/**
 * The failed step of the Production Line journey (production-lines): the
 * honest statement that the video did not finish, the server's reason, and
 * the ways forward. Moved verbatim out of ProductionLineDetailPage.tsx.
 */

import type { ReactNode } from 'react';

import type { WorkspaceCopy } from '../../merchant/copy.js';
import { Button, Card, Eyebrow, WarningIcon } from '../../merchant/ui/primitives.js';

export function FailedStep({
  copy,
  workspaceName,
  reason,
  busy,
  retryPossible,
  onRetry,
  onChooseDifferent,
  onContactSupport,
}: {
  readonly copy: WorkspaceCopy;
  readonly workspaceName: string;
  readonly reason: string | null;
  readonly busy: boolean;
  readonly retryPossible: boolean;
  readonly onRetry: () => void;
  readonly onChooseDifferent: () => void;
  readonly onContactSupport: () => void;
}): ReactNode {
  return (
    <Card
      as="section"
      padding={24}
      className="is-failed"
      aria-labelledby="fl-h"
      style={{ maxWidth: 720 }}
    >
      <Eyebrow>
        <WarningIcon />
        {copy.line.failedEyebrow}
      </Eyebrow>
      <h2 id="fl-h" className="mj-ws-h2 mj-ws-mt-8">
        {copy.line.failedTitle}
      </h2>
      {reason !== null ? <p className="mj-ws-mt-8">{reason}</p> : null}
      <p className="mj-ws-muted mj-ws-sm mj-ws-mt-8">
        {copy.line.failedBody(workspaceName)}
      </p>
      <div className="mj-ws-row mj-ws-mt-24">
        <Button
          variant="primary"
          disabled={busy || !retryPossible}
          onClick={onChooseDifferent}
        >
          {copy.line.tryAgain}
        </Button>
        <Button disabled={busy} onClick={onChooseDifferent}>
          {copy.line.chooseDifferent}
        </Button>
        <Button variant="quiet" onClick={onContactSupport}>
          {copy.line.contactSupport}
        </Button>
        <span className="mj-ws-vh">{onRetry.name}</span>
      </div>
    </Card>
  );
}
